<template>
	<div class="left-block">
		<div class="left-block-text hidden" :class="{ show:isShow() }">
			<div class="left-block-text-wrapper">
				<transition name="fade" mode="out-in">
					<img class="board-name" :src="url" alt="board-logo">
				</transition>
				<div class="content-wrapper">
					<div class="board-wrapper">
						<img class="board" src="../assets/tline.png" :class="{ show:isShowContent(2) }"/>
						<img class="board" src="../assets/fline.png" :class="{ show:isShowContent(3) }"/>
						<img class="board" src="../assets/uline.png" :class="{ show:isShowContent(4) }"/>
					</div>
					<div class="chart-wrapper">
						<img class="chart" src="../assets/chartT.png" :class="{ show:isShowContent(2) }"/>
						<img class="chart" src="../assets/chartF.png" :class="{ show:isShowContent(3) }"/>
						<img class="chart" src="../assets/chartU.png" :class="{ show:isShowContent(4) }"/>
					</div>
				</div>

				<template v-if="isShowContent(2)">
				<ul class="list">
					<li class="item">Геометрия True Twin</li>
					<li class="item">Прогиб Rocker-Camber-Rocker</li>
					<li class="item">База Durasurf Sintered 4001/8.1M</li>
					<li class="item">Стеклоткань Tri-Ax + Carbon</li>
					<li class="item">Боковые стенки Extruded UHMW</li>
					<li class="item">Сердечник Клён/Липа</li>
					<li class="item">Смола <span style="font-style: italic;">Carbon AERO</span></li>
					<li class="item">Армирование кантов <span style="font-style: italic;">KEEN System</span></li>
				</ul>
				</template>
				<template v-if="isShowContent(3)">
				<ul class="list">
					<li class="item">Геометрия Directional</li>
					<li class="item">Прогиб Rocker-Camber</li>
					<li class="item">База Durasurf Sintered 4001/8.1M</li>
					<li class="item">Стеклоткань Tri-Ax + Carbon</li>
					<li class="item">Боковые стенки Extruded UHMW</li>
					<li class="item">Сердечник Клён/Липа</li>
					<li class="item">Смола <span style="font-style: italic;">Carbon AERO</span></li>
					<li class="item">Армирование кантов <span style="font-style: italic;">KEEN System</span></li>
				</ul>
				</template>
				<template v-if="isShowContent(4)">
				<ul class="list">
					<li class="item">Геометрия Directional Twin</li>
					<li class="item">Прогиб Rocker-Camber-Rocker</li>
					<li class="item">База Durasurf Sintered 4001/8.1M</li>
					<li class="item">Стеклоткань Tri-Ax + Carbon</li>
					<li class="item">Боковые стенки Extruded UHMW</li>
					<li class="item">Сердечник Клён/Липа</li>
					<li class="item">Смола <span style="font-style: italic;">Carbon AERO</span></li>
					<li class="item">Армирование кантов <span style="font-style: italic;">KEEN System</span></li>
				</ul>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    name: 'leftBlock',
    props: ['active'],
    data () {
      return {
        url: require('../assets/phantom_t.png')
      }
    },
    methods: {
      isShow: function () {
        return this.active === 2 || this.active === 3 || this.active === 4
      },
      showName: function (index) {
        return this.active === index
      },
      isShowContent: function (index) {
        return this.active === index
      }
    },
    components: {},
    watch: {
      active: function () {
        if (this.active === 2) {
          this.url = require('../assets/phantom_t.png')
        } else if (this.active === 3) {
          this.url = require('../assets/phantom_f.png')
        } else if (this.active === 4) {
          this.url = require('../assets/phantom_u.png')
        }
      }
    }
  }
</script>

<style scoped>

	.list {
		margin-top: 32px;
		font-family: opinionprocondensed, serif;
		font-size: 26px;
		line-height: 33px;
	}

	.item {
		white-space: nowrap;
	}

	.left-block {
		max-width: 32%;
	}

	.board-title {
		font-family:stereogothic, serif;
		font-size: 28px;
		margin: 30px 0;
		color: #000;
		transition: opacity .5s;
		line-height: 30px;
	}

	.board-name {
		font-family: stereogothic, sans-serif;
		font-size: 34px;
		letter-spacing: 2px;
		color: #fafafa;
		white-space: nowrap;
		transition: opacity .5s;
		text-shadow: 1px 0 1px #000, 0 1px 1px #000, -1px 0 1px #000, 0 -1px 1px #000;
	}

	.text-header {
		font-family: opinionprocondensed, sans-serif;
		font-size: 34px;
		margin-top: 57px;
		text-transform: uppercase;
		font-weight: 400;
	}

	.text-content {
		font-family: opinionprocondensed, sans-serif;
		font-size: 24px;
		margin: 32px 0 0 0;
	}

	.left-block-text {
		font-size: 22px;
		margin: 30px 0 0 0;
	}

	.left-block-text-wrapper > p {
		font-family: opinionpro, serif;
		font-weight: 600;
		font-size: 18px;
		line-height: 20px;
	}

	.hidden {
		height: 0;
		visibility: hidden;
		opacity: 0;
	}

	.show {
		opacity: 1;
		height: auto;
		visibility: visible;
		transition: all ease-out .6s;
	}

	.board {
		position: absolute;
		opacity: 0;
		height: 0;
		visibility: hidden;
	}

	.board-wrapper {
		position: relative;
		width: 85px;
		height: 257px;
		padding-right: 35px;
	}

	.chart {
		position: absolute;
		padding-top: 43px;
		opacity: 0;
		height: 0;
		visibility: hidden;
	}

	.chart-wrapper {
		position: relative;
		width: 180px;
	}

	.content-wrapper {
		padding-top: 51px;
		display: flex;
	}

	.show {
		opacity: 1;
		height: auto;
		visibility: visible;
		transition: all ease-out .6s;
	}

	@media all and (max-width: 1350px) {
		.board {
			transform: rotate(90deg);
		}

		.content-wrapper {
			flex-direction: column;
			align-items: center;
		}

		.board-wrapper {
			width: 257px;
			height: 85px;
			padding-right: 0;
			justify-content: center;
			display: flex;
			margin-bottom: 77px;
			margin-top: -100px;
		}

		.chart-wrapper {
			width: 180px;
			height: 151px;
		}

		.board-name {
			font-size: 26px;
			width: 270px;
			text-align: center;
		}

		.list {
			margin-top: 94px;
			font-size: 20px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/LeftBlock.vue?2cd6426c